// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const charcoalKiln = defineModel({
  id: "charcoal-kiln",
  batchId: "future",
  name: "Charcoal kiln",
  tags: ["building","charcoal","kiln","low-poly","age-of-mcp","future"],
  summary: "Chars wood into charcoal — the hot fuel for smelters and glassworks.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.ConeGeometry(0.36, 0.3, 12), color: "#3a2e22", position: [-0.05, 0.29, -0.05] },
      { geometry: new THREE.ConeGeometry(0.3312, 0.15, 12), color: "#4a3a28", position: [-0.05, 0.215, -0.05] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.55, 4), color: "#6b4a26", position: [-0.42, 0.275, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.55, 4), color: "#6b4a26", position: [0.42, 0.275, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.55, 4), color: "#6b4a26", position: [-0.42, 0.275, 0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.55, 4), color: "#6b4a26", position: [0.42, 0.275, 0.42] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.ConeGeometry(0.42, 0.55, 12), color: "#3a2e22", position: [-0.05, 0.415, -0.05] },
      { geometry: new THREE.ConeGeometry(0.3864, 0.275, 12), color: "#4a3a28", position: [-0.05, 0.2775, -0.05] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [-0.42, 0.425, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [0.42, 0.425, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [-0.42, 0.425, 0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [0.42, 0.425, 0.42] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.ConeGeometry(0.44, 0.58, 12), color: "#3a2e22", position: [-0.05, 0.43, -0.05] },
      { geometry: new THREE.ConeGeometry(0.4048, 0.29, 12), color: "#4a3a28", position: [-0.05, 0.285, -0.05] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.1, 0.08, 8), color: "#1e1a16", position: [-0.05, 0.64, -0.05] },
      { geometry: new THREE.SphereGeometry(0.06, 7, 5), color: "#8a857e", position: [-0.05, 0.76, -0.05], scale: [1, 0.9, 1] },
      { geometry: new THREE.SphereGeometry(0.045, 6, 4), color: "#8a857e", position: [0.02, 0.86, -0.05], scale: [1, 0.8, 1] },
      { geometry: new THREE.BoxGeometry(0.1, 0.08, 0.06), color: "#ff7a2e", position: [-0.05, 0.19, 0.22] },
      { geometry: new THREE.CylinderGeometry(0.045, 0.045, 0.36, 7), color: "#7a5530", position: [0.34, 0.24, 0.3], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.CylinderGeometry(0.046, 0.046, 0.02, 7), color: "#9a7444", position: [0.52, 0.24, 0.3], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.CylinderGeometry(0.045, 0.045, 0.36, 7), color: "#7a5530", position: [0.34, 0.24, 0.4], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.CylinderGeometry(0.046, 0.046, 0.02, 7), color: "#9a7444", position: [0.52, 0.24, 0.4], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.CylinderGeometry(0.045, 0.045, 0.36, 7), color: "#7a5530", position: [0.34, 0.33, 0.35], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.CylinderGeometry(0.046, 0.046, 0.02, 7), color: "#9a7444", position: [0.52, 0.33, 0.35], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.CylinderGeometry(0.14, 0.16, 0.06, 10), color: "#6a665e", position: [0.34, 0.17, -0.18] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.1, 0.02, 9), color: "#1e1a16", position: [0.34, 0.21, -0.18] },
    ] },
  ],
  animations: [],
});
